import { Route } from "@angular/router";
import { NomComponent } from "./nom.component";

export const NomRouting: Route = {
  path: "nom",
  component: NomComponent,
  data: {
    breadcrumb: "Changement de nom"
  }
};
